import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
// import { AuthContext } from './AuthProvider';
import { Profile } from '../../pages/profile';
import { ContentLibrary } from '../../pages/content-library';
import Logout from '../../pages/logout/Logout';
import { Dashboard } from '../../pages/dashboard';
import MentorsPage from '../../pages/mentors-page';
import AssessmentPage from '../../pages/assessment-page';
import ProductAssessment from '../../pages/product-assessment';
import { Bookings } from '../../pages/bookings';

const UserRoutes = () => {
  return (
    <Switch>
      <Route path="/" exact component={Dashboard} />
      <Route path="/mentors" component={MentorsPage} />
      <Route path="/account" component={Profile} exact />
      <Route path="/bookings" component={Bookings} exact />
      <Route path="/exercises" component={ContentLibrary} exact />
      <Route path="/product-assessment" component={ProductAssessment} exact />
      <Route path="/assessment" component={AssessmentPage} exact />
      <Route path="/logout" component={Logout} />
      <Redirect to="/" />
    </Switch>
  );
};

export default UserRoutes;
